import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  LOGIN_SET_DEFAULT,
  LOGIN_SUBMIT,
  CHECK_FOR_TODAY_DATA,
} from "../actions/constant";
import { setAccessToken } from "../services/AuthenticationService";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  actionResponse: null,
  invalid: false,
  isReachAttempt: false,
  todaysData: false,
};

// Home reducer
function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SET_DEFAULT:
      return initialState;

    case getStarted(LOGIN_SUBMIT):
      return {
        ...state,
        isLoading: true,
        invalid: false,
        isReachAttempt: false,
      };

    case getSucceeded(LOGIN_SUBMIT):
      try {
        setAccessToken(
          action.payload.authData.access_token,
          action.payload.isRememberMe
        );
        localStorage.setItem("user", JSON.stringify(action.payload.userData));
        return { ...state, status: statusEnum.SUCCESS, isLoading: true };
      } catch (err) {
        return {
          ...state,
          actionResponse: action.payload,
          status: statusEnum.ERROR,
          invalid: false,
        };
      }

    case getFailed(LOGIN_SUBMIT):
      return {
        ...state,
        // actionResponse: action.payload,
        status: statusEnum.ERROR,
        invalid: true,
        isReachAttempt: action.payload.message === "reach_attempt",
        isLoading: false,
      };

    // case getEnded(LOGIN_SUBMIT):
    //   return { ...state, isLoading: false };

    case getSucceeded(CHECK_FOR_TODAY_DATA):
      let data = action.payload.data;
      localStorage.setItem("todaysData", JSON.stringify(data));
      return {
        ...state,
      };

    case "ACTIVE_USER":
      return { ...state };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/homeReducer.js